import { createContext, useContext, useState, useEffect } from 'react';
import api from '@/services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('auth_token');
    const userInfo = localStorage.getItem('user_info');
    
    if (token && userInfo) {
      try {
        setUser(JSON.parse(userInfo));
        setIsAuthenticated(true);
      } catch (e) {
        console.error('Failed to parse user info:', e);
        api.logout();
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const result = await api.login(username, password);
      setUser(result.userInfo);
      setIsAuthenticated(true);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const loginWithToken = async (token) => {
    try {
      api.setToken(token);
      const userInfo = await api.getUserInfo();
      localStorage.setItem('user_info', JSON.stringify(userInfo));
      setUser(userInfo);
      setIsAuthenticated(true);
      return { success: true };
    } catch (error) {
      api.logout();
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    api.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  const refreshUserInfo = async () => {
    try {
      const userInfo = await api.getUserInfo();
      setUser(userInfo);
      localStorage.setItem('user_info', JSON.stringify(userInfo));
    } catch (error) {
      console.error('Failed to refresh user info:', error);
    }
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      isAuthenticated,
      login,
      loginWithToken,
      logout,
      refreshUserInfo,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
